module.exports = __webpack_public_path__ + "static/media/report_1.6a153445.png";